import { useState } from 'react'
import classNames from 'classnames'

import {
  QA_CONTEXT_PROFILE,
  QA_NAME_PROFILE_INFO_SECTION,
  QA_SECTION_KEY,
} from '../../../constants/qa'
import { useStickyShadow } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { setRef } from '../../../utils/react'
import { EntityProfileHeaderActionsContainer } from '../EntityProfileHeaderActionsContainer'
import { EntityProfileHeaderBody } from '../EntityProfileHeaderBody'
import { EntityProfileHeaderInfoItems } from '../EntityProfileHeaderInfoItems'
import { EntityProfileHeaderTitle } from '../EntityProfileHeaderTitle'

import * as styles from './EntityProfileHeader.module.css'

function EntityProfileHeader({
  Content,
  Footer = EntityProfileHeaderActionsContainer,
  Header = EntityProfileHeaderTitle,
  InfoItems = EntityProfileHeaderInfoItems,
  bodyContentClassName,
  className = styles.EntityProfileHeader,
  contentProps,
  footerProps,
  headerProps,
  infoItemsProps,
  isLoading,
  isSticky = true,
  sectionQaName = QA_NAME_PROFILE_INFO_SECTION,
  stickyTitleClassName = styles.stickyTitle,
  stickyTitleRef,
  withPageStickyTitle,
  onClickEditTitleButton,
  onCloseModal,
  onSetFiles,
  onSetModal,
}) {
  const { isStuck, ref: stickyRef } = useStickyShadow()

  const [isHeaderOpen, setHeaderOpen] = useState(true)

  function handleStickyTitleRef(node) {
    setRef(stickyRef, node)
    setRef(stickyTitleRef, node)
  }

  const sectionQaProps = getQaSelector(
    { context: QA_CONTEXT_PROFILE, value: sectionQaName },
    QA_SECTION_KEY
  )

  function handleToggleHeader() {
    setHeaderOpen(prev => !prev)
  }

  const titleNode = (
    <Header
      {...headerProps}
      actionsProps={{
        ...headerProps?.actionsProps,
        onClickEditTitleButton,
        onToggleHeader: handleToggleHeader,
      }}
      isHeaderOpen={isHeaderOpen}
      isLoading={isLoading}
    />
  )

  const bodyNode =
    InfoItems || Content || Footer ? (
      <EntityProfileHeaderBody
        Content={Content}
        Footer={Footer}
        InfoItems={InfoItems}
        contentClassName={bodyContentClassName}
        contentProps={contentProps}
        footerProps={footerProps}
        infoItemsProps={infoItemsProps}
        isLoading={isLoading}
        isOpen={isHeaderOpen}
        sectionQaProps={sectionQaProps}
        withPageStickyTitle={withPageStickyTitle}
        onCloseModal={onCloseModal}
        onSetFiles={onSetFiles}
        onSetModal={onSetModal}
      />
    ) : null

  const stickyHeaderNode = (
    <div
      className={classNames(stickyTitleClassName, {
        [className]: !bodyNode,
        [styles.shadow]: isStuck,
      })}
      ref={handleStickyTitleRef}
    >
      {titleNode}
    </div>
  )

  return isSticky && !bodyNode ? (
    stickyHeaderNode
  ) : withPageStickyTitle ? (
    <>
      {stickyHeaderNode}
      {bodyNode}
    </>
  ) : (
    <div {...sectionQaProps} className={className}>
      {isSticky ? stickyHeaderNode : titleNode}
      {bodyNode}
    </div>
  )
}

export default EntityProfileHeader
